/**
 * Scripts spécifiques aux pages aftermarket.
 */
import "./main";
import { Branches } from "./modules/branches";
// Instancier le module de sélection de branches
new Branches();
